import angular from 'angular';
import {HelloSignClientService} from './hellosign-client.service';
import { HelloSignClientConstantsModule } from '../../constants/esignatures-constants.module';

export const ESignaturesHelloSignClientServiceModule = angular.module('buildium.draft-leases.esignatures.helloSignClientService', [
    HelloSignClientConstantsModule.name
])
    .service('HelloSignClientService', HelloSignClientService);
